<template>
  <v-data-table
    :headers="headers"
    :items="contatti"
    sort-by="tipo"
    class="elevation-1"
    dense
    hide-default-footer
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-dialog v-model="dialog" max-width="1000px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" dense>
              Nuovo contatto
            </v-btn>
            <v-spacer></v-spacer>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4" >
                    <!-- <v-text-field v-model="editedItem.tipo" label="Tipo"></v-text-field> -->
                    <v-select v-model="editedItem.tipo" :items="tipiContatto" label="Tipo" item-text="descrizione" item-value="codice" hide-details :return-object="true"></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItem.nome" label="Nome"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItem.cognome" label="Cognome" ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItem.telefono" label="Telefono"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItem.cellulare" label="Cellulare"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItem.pec" label="Pec"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="close"
              >
                Annulla
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
              >
                Salva
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Sei sicuro di voler cancellare questo contatto?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Annulla</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      Nessun contatto definito
<!--       <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn> -->
    </template>
  </v-data-table>
</template>

<script>
  import configurazioni from '@/services/configurazioniService.js'
  /* eslint-disable */
  export default {
    props: {
      idCliente: String,
      contatti: Array
    },
    data: () => ({
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: 'Tipo',
          align: 'start',
          sortable: false,
          value: 'tipo.descrizione',
        },
        { text: 'Nome', value: 'nome' },
        { text: 'Cognome', value: 'cognome' },
        { text: 'Telefono', value: 'telefono' },
        { text: 'Cellulare', value: 'cellulare' },
        { text: 'Email', value: 'email' },
        { text: 'Pec', value: 'pec' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      // contatti: [],
      editedIndex: -1,
      editedItem: {
        tipo: '',
        nome: '',
        cognome: '',
        telefono:  '',
        cellulare:  '',
        email:  '',
        pec:  ''
      },
      defaultItem: {
        tipo: 'titolare', //  verificare{ codice: 'titolare', descrizione: 'Titolare' },
        nome:  '',
        cognome:  '',
        telefono:  '',
        cellulare: '',
        email:  '',
        pec:  ''
      },
      tipiContatto: [],
      tipiDefault: [{ codice: 'titolare', descrizione: 'Titolare' }, { codice: 'amministrazione', descrizione: 'Amministrazione' }, { codice: 'commerciale', descrizione: 'Commerciale' }]
    }),
    async mounted() {
      this.tipiContatto = await configurazioni.getConfigurazione('documenti_parametri', 'tipiContatto')
      if (this.tipiContatto.length === 0) {
        this.tipiContatto = this.tipiDefault
      }
    },    
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuovo contatto' : 'Modifica contatto'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    methods: {
      editItem (item) {
        this.editedIndex = this.contatti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.contatti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.$emit('delete-contatto', { idCliente: this.idCliente, contatto: this.editedItem })
        this.contatti.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.contatti[this.editedIndex], this.editedItem)
          this.$emit('update-contatto', { idCliente: this.idCliente, contatto: this.editedItem })
        } else {
          this.$emit('new-contatto', { idCliente: this.idCliente, contatto: this.editedItem })
          this.contatti.push(this.editedItem)
        }
        this.close()
      }
    }
  }
</script>
